export enum FormState {
  Default,
  Valid,
  Error,
}

export type Color = "rose" | "indigo" | "slate" | "white" | "violet";
